import $api2 from '@/plugins/axiosInstance2.js'

const BASE = '/admin/royalty-reporting'
const HOLIDAY = '/admin/holiday'

function unwrap(res) {
  return res && res.data && Object.prototype.hasOwnProperty.call(res.data, 'data') ? res.data.data : res && res.data
}

export const RoyaltyReportingApi = {
  // ---- Window / override ----
  getWindow(month) {
    return $api2.get(`${BASE}/window`, { params: month ? { month } : {} }).then(unwrap)
  },
  setOverride(body) {
    return $api2.put(`${BASE}/override`, body).then(unwrap)
  },
  clearOverride(month) {
    return $api2.delete(`${BASE}/override`, { params: { month } })
  },

  // ---- Holidays (lookup_holiday) ----
  listHolidays(params = {}) {
    return $api2.get(HOLIDAY, { params }).then(unwrap)
  },
  addHoliday(body) {
    return $api2.post(HOLIDAY, body).then(unwrap)
  },
  updateHoliday(id, body) {
    return $api2.put(`${HOLIDAY}/${encodeURIComponent(id)}`, body).then(unwrap)
  },
  removeHoliday(id) {
    return $api2.delete(`${HOLIDAY}/${encodeURIComponent(id)}`)
  },
}

/** Current month 'YYYY-MM' in KST (matches the backend's todayKst). */
export function currentMonthKst() {
  const kst = new Date(Date.now() + 9 * 60 * 60 * 1000)
  const y = kst.getUTCFullYear()
  const m = String(kst.getUTCMonth() + 1).padStart(2, '0')
  return `${y}-${m}`
}
